import { render } from "./MainMenuView.vue?vue&type=template&id=83ce2678&scoped=true"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=83ce2678&scoped=true&lang=css"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ce2678"]])

export default __exports__